'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _componentsComponent = require('../../components/Component');

var _componentsComponent2 = _interopRequireDefault(_componentsComponent);

var _componentsDatagrid = require('../../components/Datagrid');

var _componentsDatagrid2 = _interopRequireDefault(_componentsDatagrid);

var _helpersRenderers = require('../../helpers/Renderers');

var _helpersRenderers2 = _interopRequireDefault(_helpersRenderers);

var _dbinfo = require('../../dbinfo');

var _dbinfo2 = _interopRequireDefault(_dbinfo);

var _constants = require('../../constants');

var _constants2 = _interopRequireDefault(_constants);

var _reactisForms = require('reactis-forms');

var _reactisInputs = require('reactis-inputs');

var _reactisDatagrid = require('reactis-datagrid');

var _reactBootstrap = require('react-bootstrap');

var _reactisModal = require('reactis-modal');

var _EventEmitter = require('../../EventEmitter');

var _EventEmitter2 = _interopRequireDefault(_EventEmitter);

var _componentsFormDateRange = require('../../components/Form/DateRange');

var _componentsFormDateRange2 = _interopRequireDefault(_componentsFormDateRange);

var _reactDocumentTitle = require('react-document-title');

var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);

var _reactRedux = require('react-redux');

var _componentsFormActiveSelect = require('../../components/Form/ActiveSelect');

var _componentsFormActiveSelect2 = _interopRequireDefault(_componentsFormActiveSelect);

var _redux = require('redux');

var _components = {
	_$List: {
		displayName: 'List'
	}
};

function _wrapComponent(uniqueId) {
	return function (ReactClass) {
		return ReactClass;
	};
}

var List = (function (_Component) {
	_inherits(List, _Component);

	function List(props, context) {
		var _this = this;

		_classCallCheck(this, _List);

		_Component.call(this, props);

		var rendererLink = function rendererLink(val, row) {
			return _react2['default'].createElement(
				'a',
				{ href: '/user/' + row.id, onClick: function (e) {
						return _this.handleOpen(row, e);
					} },
				val
			);
		};

		this.columnModel = [{
			name: 'id',
			title: 'ID',
			field: 'id',
			width: 40,
			viewport: 'tablet',
			align: 'center'
		}, {
			name: 'image',
			title: 'Foto',
			field: 'image',
			sortable: false,
			width: 60,
			viewport: 'tablet',
			align: 'center',
			renderer: function renderer(val) {
				if (val) {
					return _react2['default'].createElement('img', { src: val.url, style: { height: val.height, width: val.width } });
				}
			}
		}, {
			name: 'name',
			title: 'Jméno',
			field: 'name',
			renderer: rendererLink
		}, {
			name: 'surname',
			title: 'Příjmení',
			field: 'surname',
			renderer: rendererLink
		}, {
			name: 'email',
			title: 'E-mail',
			field: 'email',
			viewport: 'tablet'
		}, {
			name: 'active',
			title: 'Aktivní',
			field: 'active',
			width: 60,
			align: 'center',
			viewport: 'tablet',
			renderer: _helpersRenderers2['default'].coloredCheck
		}, {
			name: 'edit',
			title: 'Edit',
			field: 'id',
			width: 80,
			sortable: false,
			renderer: function renderer(val, row) {
				return _react2['default'].createElement(
					'a',
					{ href: '/user/' + val, onClick: function (e) {
							return _this.handleOpen(row, e);
						} },
					_react2['default'].createElement('i', { className: 'fa fa-pencil' }),
					' Upravit'
				);
			}
		}];

		var filterSchema = {
			id: { 'class': _reactisInputs.FilterInput },
			name: { 'class': _reactisInputs.FilterInput },
			surname: { 'class': _reactisInputs.FilterInput },
			email: { 'class': _reactisInputs.FilterInput },
			image: { 'class': _reactisInputs.Select, options: [{ id: '1', title: 'Má' }, { id: '0', title: 'Nemá' }], placeholder: '---' },
			active: { 'class': _reactisInputs.Select, options: [{ id: '1', title: 'Ano' }, { id: '0', title: 'Ne' }], placeholder: '---' },
			fulltext: { 'class': _reactisInputs.SearchInput },
			edit: {
				'class': _reactisDatagrid.FilterResetButton,
				visible: function visible() {
					return _this.filter.isChanged();
				},
				onClick: function onClick() {
					return _this.filter.reset();
				}
			}
		};
		this.filter = new _reactisForms.FormManager(filterSchema);
		this.defaultSort = this.props.defaultState ? this.props.defaultState.sort : { column: 'id', 'direction': 'asc' };
		this.defaultFilter = this.props.defaultState ? this.props.defaultState.filter : {};
	}

	List.prototype.componentDidMount = function componentDidMount() {
		var _this2 = this;

		this.changeListener = function () {
			_this2.refs.datagrid.getWrappedInstance().refresh();
		};
		_EventEmitter2['default'].on('user.change', this.changeListener);
	};

	List.prototype.componentWillUnmount = function componentWillUnmount() {
		_EventEmitter2['default'].removeListener('user.change', this.changeListener);
	};

	List.prototype.handleOpen = function handleOpen(row, e) {
		e.preventDefault();
		this.props.actions.openTabForm('user', row.title, row);
	};

	List.prototype.handleNewClick = function handleNewClick(e) {
		e.preventDefault();
		this.props.onNewTab();
	};

	List.prototype.render = function render() {
		var _this3 = this;

		var buttons = _react2['default'].createElement(
			_reactBootstrap.Button,
			{ href: '/user/0', onClick: function (e) {
					return _this3.handleNewClick(e);
				} },
			_react2['default'].createElement('i', { className: 'fa fa-plus' }),
			' Nový uživatel'
		);

		return _react2['default'].createElement(_componentsDatagrid2['default'], {
			ref: 'datagrid',
			id: 'user',
			api: 'user.getList',
			buttons: buttons,
			filters: ['fulltext'],
			filter: this.filter,
			saveState: true,
			columnModel: this.columnModel,
			defaultFilter: this.defaultFilter,
			defaultSort: this.defaultSort
		});
	};

	var _List = List;
	List = _wrapComponent('_$List')(List) || List;
	List = _reactRedux.connect(function (state, props) {
		return {
			defaultState: state.datagridDefaultState[props.module]
		};
	})(List) || List;
	return List;
})(_componentsComponent2['default']);

exports['default'] = List;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/User/List.js
 ** module id = 998
 ** module chunks = 2
 **/